import { render, staticRenderFns } from "./ModulesPage.vue?vue&type=template&id=37e51f88&scoped=true&"
import script from "./ModulesPage.vue?vue&type=script&lang=js&"
export * from "./ModulesPage.vue?vue&type=script&lang=js&"
import style0 from "./ModulesPage.vue?vue&type=style&index=0&id=37e51f88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e51f88",
  null
  
)

export default component.exports